import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  PublishProductError,
  PublishProduct,
  PublishProductSuccess,
} from '../action-creators';
import { PUBLISH_PRODUCT } from '../actions';
import ApiError from '@common/types/api/api-error';
import { merchReleaseCompletedEvent } from '@webapp/utils/rudderstack/events';
import AppState from '@webapp/store/state';

export const publishProductEpic = (
  action$: Observable<Actions>,
  $state: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, PublishProduct>(PUBLISH_PRODUCT),
    withLatestFrom($state),
    mergeMap(async ([action, state]) => {
      try {
        await merch.publish(action.artistId, action.productId);
        const catalogProduct =
          state.merch.artistMerch.find(
            (merch) => merch.id === action.productId
          ) || state.merch.active?.editProduct;

        const newProduct = state.merch.active?.newProduct;
        if (window.analytics) {
          window.analytics.track('Products Published', {
            product_id: action.productId,
            variants: catalogProduct?.variants,
            price: catalogProduct?.price,
            cost: catalogProduct?.cost,
          });
        }
        if (catalogProduct) {
          merchReleaseCompletedEvent({
            product_id: catalogProduct.id,
            product_name: catalogProduct.title,
            suggested_price: catalogProduct.price,
            is_edit: true,
            currency: 'USD',
            artist_id: action.artistId,
            artist_name: state.artist?.active?.name,
          });
        } else if (newProduct) {
          merchReleaseCompletedEvent({
            product_id: newProduct.productId,
            product_name: state.merch.active?.productData?.productName,
            suggested_price: state.merch.active?.productData?.productPrice
              ? +state.merch.active.productData.productPrice * 100
              : 0,
            is_edit: true,
            currency: 'USD',
            artist_id: action.artistId,
            artist_name: state.artist?.active?.name,
          });
        }
        return new PublishProductSuccess(action.productId);
      } catch (err) {
        return new PublishProductError((err as ApiError).message);
      }
    })
  );
